import { render, staticRenderFns } from "./Patent.vue?vue&type=template&id=6f7ce8ec&scoped=true&"
import script from "./Patent.vue?vue&type=script&lang=js&"
export * from "./Patent.vue?vue&type=script&lang=js&"
import style0 from "./Patent.vue?vue&type=style&index=0&id=6f7ce8ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7ce8ec",
  null
  
)

export default component.exports